import { render, staticRenderFns } from "./mygroup.vue?vue&type=template&id=539fcbd1&scoped=true"
import script from "./mygroup.vue?vue&type=script&lang=js"
export * from "./mygroup.vue?vue&type=script&lang=js"
import style0 from "./mygroup.vue?vue&type=style&index=0&id=539fcbd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539fcbd1",
  null
  
)

export default component.exports